import { BaseError } from '@belimo-retrofit-portal/logic';

export class CancelledError extends BaseError {
  public constructor(
    message: string,
    context?: unknown,
    previous?: BaseError,
  ) {
    super(message, previous);
  }

  public get name(): string {
    return 'CancelledError';
  }
}
